export enum HeaderedPageType {
  NORMAL,
  LARGE_PADDING
}
